export const toolbarGroupHeader =
    "<header>"
    + '    <div class="title"></div>'
    + '    <a href="#" class="close icon close-icon-base64" id="toolbar-close-icon"></a>'
    + "</header>";
